import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { ArrowLongRightIcon, CheckCircleIcon } from "@heroicons/react/24/outline";
import { NavbarTwo } from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import manufacturingImage from "../asset/Manufacturing.png";
import researchImage from "../asset/research.png";
import precisionImage from "../asset/precisionone/capsule.png";
import testingImage from "../asset/testing.png";
import qualityImage from "../asset/image10.png";
import packagingImage from "../asset/packaging.png";
import packagingFolderImageOne from "../asset/packaging/WhatsApp Image 2026-10-09 at 15.42.08.jpeg";
import packagingFolderImageTwo from "../asset/packaging/WhatsApp Image 2026-10-09 at 15.42.39.jpeg";
import packagingFolderImageThree from "../asset/packaging/WhatsApp Image 2026-10-09 at 15.54.07 (1).jpeg";
import qualityFolderImageOne from "../asset/quality/0S0A0714_1_11zon.webp";
import qualityFolderImageTwo from "../asset/quality/two.jpeg";
import qualityFolderImageThree from "../asset/quality/three.webp";
import qualityFolderImageFour from "../asset/quality/four.webp";
import testingHomeImage from "../asset/homewhatwedo/testinghome.png";
import testingQualityImage from "../asset/homewhatwedo/quality.png";
import testingPrecisionImage from "../asset/homewhatwedo/precisioncomponents.webp";
import precisionTwoImageOne from "../asset/precision2/1.jpg";
import precisionTwoImageTwo from "../asset/precision2/2.png";
import precisionTwoImageThree from "../asset/precision2/3.jpg";
import precisionTwoImageFour from "../asset/precision2/4.jpg";
import precisionTwoImageFive from "../asset/precision2/5.jpg";
import manufacturingImageOne from "../asset/manufacturing/0S0A0811_1_11zon.webp";
import manufacturingImageTwo from "../asset/manufacturing/two.webp";
import manufacturingImageThree from "../asset/manufacturing/three.webp";
import manufacturingImageFour from "../asset/manufacturing/0S0A0842_4_11zon.webp";
import manufacturingImageFive from "../asset/manufacturing/five.webp";
import manufacturingImageSix from "../asset/manufacturing/0S0A0848_6_11zon.webp";
import testingFolderImageOne from "../asset/testing/1.webp";
import testingFolderImageTwo from "../asset/testing/2.webp";
import testingFolderImageThree from "../asset/testing/3.webp";
import testingFolderImageFour from "../asset/testing/4.webp";
import testingFolderImageFive from "../asset/testing/5.webp";
import "./CapabilitiesPage.css";

const infrastructure = [
  { id: "research-development", number: "01", title: "Design, research & development", summary: "From concept development to optimized, production-ready designs." },
  { id: "manufacturing", number: "02", title: "Manufacturing", summary: "High-precision conventional and CNC-VMC manufacturing in Thane." },
  { id: "precision-components", number: "03", title: "Precision components", summary: "High-precision components and assemblies built to demanding standards." },
  { id: "quality", number: "04", title: "Quality assurance", summary: "Dimensional, geometric and non-destructive inspection." },
  { id: "testing", number: "05", title: "Testing facilities", summary: "Specialized testing and validation for reliable performance." },
  { id: "packing-forwarding", number: "06", title: "Packing & forwarding", summary: "Careful handling and delivery of precision-engineered products." },
];

const testingFacilities = [
  "Helium leak detector testing facility",
  "Pneumatic pressure testing facility",
  "Hydraulic pressure testing facility",
  "Spring load rate testing machine",
  "Heat treatment furnace",
  "Full-fledged NDT facilities: ultrasonic, magnetic particle and dye penetrant",
  "Dedicated assembly room for final checks",
  "Chemical analysis: applicable material-specific ASTM methods",
  "Tensile testing: ASTM E8/E8M",
  "Rockwell hardness: ASTM E18",
  "Impact testing: ASTM E23",
  "Metallographic preparation and microetching: ASTM E3 / E407",
];

const qualityEquipment = [
  "CMM (500 × 600 × 400)",
  "Surface tester",
  "Profile projector",
  "Hardness tester",
  "Electronic height gauge",
];

const testingImages = [testingFolderImageOne, testingFolderImageTwo, testingFolderImageThree, testingFolderImageFour, testingFolderImageFive];
const qualityImages = [qualityFolderImageOne, qualityFolderImageTwo, qualityFolderImageThree, qualityFolderImageFour];
const precisionImages = [precisionTwoImageOne, precisionTwoImageTwo, precisionTwoImageThree, precisionTwoImageFour, precisionTwoImageFive];
const manufacturingImages = [manufacturingImageOne, manufacturingImageTwo, manufacturingImageThree, manufacturingImageFour, manufacturingImageFive, manufacturingImageSix];

const CapabilitySection = ({ item, image, children, reverse = false }) => (
  <article className={`capability-detail ${reverse ? "capability-detail--reverse" : ""}`} id={item.id}>
    <div className="capability-detail__copy">
      <p className="capability-detail__number">{item.number} / Infrastructure</p>
      <h2>{item.title}</h2>
      <div className="capability-detail__content">{children}</div>
    </div>
    {item.id === "packing-forwarding" ? (
      <div className="capability-detail__image capability-detail__image--triple" aria-label="Packaging and forwarding images">
        {[packagingFolderImageOne, packagingFolderImageTwo, packagingFolderImageThree].map((packagingAsset, index) => (
          <div className={`capability-detail__image-card capability-detail__image-card--${index + 1}`} key={packagingAsset}>
            <img src={packagingAsset} alt="" />
          </div>
        ))}
      </div>
    ) : item.id === "precision-components" ? (
      <div className="capability-detail__image capability-detail__image--quint" aria-label="Precision components images">
        {precisionImages.map((asset, index) => (
          <div className={`capability-detail__image-card capability-detail__precision-card--${index + 1}`} key={asset}>
            <img src={asset} alt="" />
          </div>
        ))}
      </div>
    ) : item.id === "manufacturing" ? (
      <div className="capability-detail__image capability-detail__image--manufacturing-six" aria-label="Manufacturing images">
        {manufacturingImages.map((asset, index) => (
          <div className={`capability-detail__image-card capability-detail__manufacturing-card--${index + 1}`} key={asset}>
            <img src={asset} alt="" />
          </div>
        ))}
      </div>
    ) : item.id === "quality" ? (
      <div className="capability-detail__image capability-detail__image--quality-quad" aria-label="Quality assurance images">
        {qualityImages.map((asset, index) => (
          <div className={`capability-detail__image-card capability-detail__quality-card--${index + 1}`} key={asset}>
            <img src={asset} alt="" />
          </div>
        ))}
      </div>
    ) : item.id === "testing" ? (
      <div className="capability-detail__image capability-detail__image--testing-five" aria-label={`${item.title} images`}>
        {testingImages.map((asset, index) => (
          <div className={`capability-detail__image-card capability-detail__testing-five-card--${index + 1}`} key={asset}>
            <img src={asset} alt="" />
          </div>
        ))}
      </div>
    ) : image && <div className="capability-detail__image capability-detail__image--animated"><img src={image} alt="" /></div>}
  </article>
);

const scrollToInfrastructureSection = (event, sectionId) => {
  event.preventDefault();
  document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth", block: "start" });
  window.history.replaceState(null, "", `#${sectionId}`);
};

const CapabilitiesPage = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const sectionId = searchParams.get("section");
    if (!sectionId) return;

    const section = document.getElementById(sectionId);
    if (section) {
      window.setTimeout(() => section.scrollIntoView({ behavior: "smooth", block: "start" }), 0);
    }
  }, [searchParams]);

  return (
  <div className="capabilities-page">
    <NavbarTwo />
    <main className="capabilities-main">
      <section className="capabilities-hero">
        <div>
          <p className="capabilities-eyebrow">Capabilities & infrastructure</p>
          <h1>Built for precision.<br /><em>Ready for complexity.</em></h1>
          <p className="capabilities-hero__intro">
            A single view of the people, equipment and systems that take a component from idea to dependable delivery.
          </p>
        </div>
        <a className="capabilities-hero__jump" href="#infrastructure-list">
          Explore infrastructure <ArrowLongRightIcon />
        </a>
      </section>

      <section className="infrastructure-list" id="infrastructure-list" aria-labelledby="infrastructure-title">
        <div className="infrastructure-list__heading">
          <p className="capabilities-eyebrow">One integrated setup</p>
          <h2 id="infrastructure-title">Our infrastructure</h2>
        </div>
        <div className="infrastructure-list__grid">
          {infrastructure.map((item) => (
            <a
              className="infrastructure-link"
              href={`#${item.id}`}
              onClick={(event) => scrollToInfrastructureSection(event, item.id)}
              key={item.id}
            >
              <span>{item.number}</span>
              <div><h3>{item.title}</h3><p>{item.summary}</p></div>
              <ArrowLongRightIcon />
            </a>
          ))}
        </div>
      </section>

      <section className="capability-details" aria-label="Infrastructure details">
        <CapabilitySection item={infrastructure[0]} image={researchImage}>
          <p>Our Design, Research and Development division uses SolidWorks, AutoCAD and Siemens NX to turn customer requirements into precise, manufacturable solutions.</p>
          <p>Advanced simulation and modelling help optimize performance, durability and manufacturability for the Automotive, Power, Energy, Packaging and Oil & Gas sectors. Our team develops mechanical seals, hydraulic fittings, valves, drive mechanisms and high-precision rotary shafts.</p>
        </CapabilitySection>

        <CapabilitySection item={infrastructure[1]} image={manufacturingImage} reverse>
          <p>Our Thane manufacturing unit combines high-precision conventional and CNC-VMC machinery with a knowledgeable technical team and skilled workforce.</p>
          <p>We manufacture precision components, sub-assemblies and assemblies in special-grade alloys, including stainless steel, Inconel, Titanium, Ceramic, Tungsten Carbide, Silicon Carbide and Carbon/Graphite grades.</p>
        </CapabilitySection>

        <CapabilitySection item={infrastructure[2]} image={precisionImage}>
          <p>We produce high-precision components and assemblies for demanding industrial applications, with close attention to dimensional accuracy, material selection and performance.</p>
          <p>Our teams work across special-grade alloys and engineered materials to deliver dependable parts that meet exact customer and application requirements.</p>
        </CapabilitySection>

        <CapabilitySection item={infrastructure[3]} image={qualityImage} reverse>
          <p>Quality is monitored throughout production. Our experienced quality personnel manage inspections and QA plans to ensure every product meets its exact specification.</p>
          <div className="capability-columns">
            <div><h3>Control equipment</h3><ul>{qualityEquipment.map((item) => <li key={item}>{item}</li>)}</ul></div>
            <div><h3>Inspection facilities</h3><ul><li>Dimensional & geometric inspection</li></ul></div>
          </div>
          <p>Our manufacturing unit is accredited to ISO 9001:2015 for quality management systems.</p>
        </CapabilitySection>

        <CapabilitySection item={infrastructure[4]} image={testingImage}>
          <p>Our testing infrastructure helps validate component integrity, pressure performance, material properties and final assembly quality before delivery.</p>
          <ul className="capability-checklist">
            {testingFacilities.map((facility) => <li key={facility}><CheckCircleIcon />{facility}</li>)}
          </ul>
        </CapabilitySection>

        <CapabilitySection item={infrastructure[5]} image={packagingImage}>
          <p>Dedicated packing and forwarding processes protect precision components and assemblies from the manufacturing floor to their destination.</p>
          <p>Products are handled, packed and documented with attention to identification, protection and delivery requirements, helping maintain the same quality standard beyond our facility.</p>
        </CapabilitySection>
      </section>
    </main>
    <Footer />
  </div>
  );
};

export default CapabilitiesPage;
